module.exports = __webpack_public_path__ + "img/config_icon.8e3883a1.svg";